<template>
  <div class="admin-root">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from './stores/auth'

const router = useRouter()
const auth = useAuthStore()

function onExpired() {
  auth.clear()
  const current = router.currentRoute.value
  if (current.name !== 'login') {
    router.replace({ name: 'login', query: { redirect: current.fullPath } })
  }
}

onMounted(() => {
  window.addEventListener('auth:expired', onExpired)
})

onUnmounted(() => {
  window.removeEventListener('auth:expired', onExpired)
})
</script>

<style>
html,
body,
#app {
  margin: 0;
  height: 100%;
}
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
}
</style>
